export enum PermissionTypes {
	Permissions_Roles_View = 'Permissions.Roles.View',
	Permissions_Roles_Create = 'Permissions.Roles.Create',
	Permissions_Roles_Update = 'Permissions.Roles.Update',
	Permissions_Roles_Delete = 'Permissions.Roles.Delete',

	Permissions_Users_View = 'Permissions.Users.View',
	Permissions_Users_Create = 'Permissions.Users.Create',
	Permissions_Users_Update = 'Permissions.Users.Update',
	Permissions_Users_Delete = 'Permissions.Users.Delete',

	Permissions_ManageLookUps_View = 'Permissions.ManageLookUps.View',
	Permissions_ManageLookUps_Create = 'Permissions.ManageLookUps.Create',
	Permissions_ManageLookUps_Update = 'Permissions.ManageLookUps.Update',

	Permissions_ManageSettings_View = 'Permissions.ManageSettings.View',
	Permissions_ManageSettings_Update = 'Permissions.ManageSettings.Update',

	Permissions_EmailLog_View = 'Permissions.EmailLog.View',

	Permissions_AuditLogs_View = 'Permissions.AuditLogs.View',
	Permissions_AuditLogs_Export = 'Permissions.AuditLogs.Export',

	Permissions_ManagePlatformLookUps_View = 'Permissions.ManagePlatformLookUps.View',
	Permissions_ManagePlatformLookUps_Create = 'Permissions.ManagePlatformLookUps.Create',
	Permissions_ManagePlatformLookUps_Update = 'Permissions.ManagePlatformLookUps.Update',

	Permissions_EmailTemplates_View = 'Permissions.EmailTemplates.View',
	Permissions_EmailTemplates_Create = 'Permissions.EmailTemplates.Create',
	Permissions_EmailTemplates_Update = 'Permissions.EmailTemplates.Update',
	Permissions_EmailTemplates_Delete = 'Permissions.EmailTemplates.Delete',

	Permissions_CountryLocalization_Create = 'Permissions.CountryLocalization.Create',
	Permissions_CountryLocalization_Update = 'Permissions.CountryLocalization.Update',
	Permissions_CountryLocalization_Delete = 'Permissions.CountryLocalization.Delete',
	Permissions_CountryLocalization_View = 'Permissions.CountryLocalization.View',

	Permissions_Tenants_View = 'Permissions.Tenants.View',
	Permissions_Tenants_Update = 'Permissions.Tenants.Update',

	Permissions_MySubscriptions_View = 'Permissions.MySubscriptions.View',
	Permissions_MySubscriptions_Purchase = 'Permissions.MySubscriptions.Purchase',

	Permissions_SubscriptionPlans_View = 'Permissions.SubscriptionPlans.View',
	Permissions_SubscriptionPlans_Create = 'Permissions.SubscriptionPlans.Create',
	Permissions_SubscriptionPlans_Update = 'Permissions.SubscriptionPlans.Update',
	Permissions_SubscriptionPlans_Delete = 'Permissions.SubscriptionPlans.Delete',

	Permissions_SupportInquiries_View = 'Permissions.SupportInquiries.View',
	Permissions_SupportInquiries_Create = 'Permissions.SupportInquiries.Create',

	Permissions_SupportDocuments_View = 'Permissions.SupportDocuments.View',
	Permissions_SupportDocuments_Create = 'Permissions.SupportDocuments.Create',
	Permissions_SupportDocuments_Delete = 'Permissions.SupportDocuments.Delete',

	Permissions_PromoCodes_View = 'Permissions.PromoCodes.View',
	Permissions_PromoCodes_Create = 'Permissions.PromoCodes.Create',
	Permissions_PromoCodes_Update = 'Permissions.PromoCodes.Update',
	Permissions_PromoCodes_Delete = 'Permissions.PromoCodes.Delete',

	Permissions_Campaigns_View = 'Permissions.Campaigns.View',
	Permissions_Campaigns_Create = 'Permissions.Campaigns.Create',
	Permissions_Campaigns_Update = 'Permissions.Campaigns.Update',
	Permissions_Campaigns_Delete = 'Permissions.Campaigns.Delete',

	Permissions_CustomPricing_View = 'Permissions.CustomPricing.View',
	Permissions_CustomPricing_Update = 'Permissions.CustomPricing.Update',

		Permissions_SqlDbdInstaller_View = 'Permissions.SqlDbdInstaller.View',
	Permissions_SqlDbdInstaller_Create = 'Permissions.SqlDbdInstaller.Create',
}

export const ADMINISTRATOR_MENU_PERMISSIONS = [
	PermissionTypes.Permissions_Roles_View,
	PermissionTypes.Permissions_Users_View,
	PermissionTypes.Permissions_SubscriptionPlans_View,
	PermissionTypes.Permissions_Tenants_View,
	PermissionTypes.Permissions_PromoCodes_View,
	PermissionTypes.Permissions_Campaigns_View,
	PermissionTypes.Permissions_CustomPricing_View,
	PermissionTypes.Permissions_ManagePlatformLookUps_View,
	PermissionTypes.Permissions_ManageLookUps_View,
	PermissionTypes.Permissions_ManageSettings_View,
] as const
